import * as d3 from "d3";
import { Chart } from "./Chart";
import i18n from "../lang/lang";

export function ChartBarStackedHorizontal(
  alias,
  chartData,
  normalized,
  showAxisPercentage
) {
  this.alias = alias;
  this.chartData = chartData;
  this.data = chartData.data;
  this.normalized = normalized || false;
  this.showAxisPercentage = showAxisPercentage || false;

  const chart = new Chart(alias);

  this.render = function () {
    const keys = [];
    const data = [];

    for (let i in this.data[0].group) {
      keys.push(this.data[0].group[i].label);
    }

    for (let j in this.data) {
      const tempObjt = {
        label: this.data[j].label,
      };
      let tempTotal = 0;
      for (let k in this.data[j].group) {
        tempObjt[this.data[j].group[k].label] =
          this.data[j].group[k].value || 0;
        tempTotal += this.data[j].group[k].value || 0;
      }
      tempObjt.total = tempTotal;
      data.push(tempObjt);
    }

    const y = d3
      .scaleBand()
      .rangeRound([0, chart.chartHeight])
      .padding(0.3)
      .domain(
        data.map(function (d) {
          return i18n.tc(d.label);
        })
      );

    const x = d3.scaleLinear().rangeRound([0, chart.chartWidth]);

    const stack = d3.stack();
    if (this.normalized) {
      stack.order(d3.stackOrderNone).offset(d3.stackOffsetExpand);
    } else {
      x.domain([
        0,
        d3.max(data, function (d) {
          return d.total;
        }),
      ]).nice();
    }

    const g = chart.svg.append("g");
    g.append("g")
      .selectAll("g")
      .data(stack.keys(keys)(data))
      .enter()
      .append("g")
      .attr("fill", (d) => {
        const label = d.key;

        if (d.key.includes("_option_")) {
          return i18n.tc(`label_reports_graph_response${d.index + 1}_color`);
        } else {
          return chart.getColor(label);
        }
      })
      .selectAll("rect")
      .data(function (d) {
        return d;
      })
      .enter()
      .append("rect")
      .attr("y", (d) => {
        return y(i18n.tc(d.data.label));
      })
      .attr("x", (d) => {
        return x(d[0]);
      })
      .attr("width", (d) => {
        return x(d[1]) - x(d[0]);
      })
      .attr("height", y.bandwidth())
      .on("mouseover", function (d) {
        console.log(d);
        chart.openTooltip(i18n.tc(d.data.label) + ": " + d.data.total);
      })
      .on("mouseout", function () {
        chart.closeTooltip();
      })
      .on("mousemove", function () {
        var coordinates = d3.mouse(this);
        chart.moveTooltip(coordinates[0], coordinates[1] - 30);
      });

    chart.drawAxis(
      x,
      y,
      this.chartData.xAxis,
      this.chartData.yAxis,
      this.showAxisPercentage
    );
  };
}
